import { render, staticRenderFns } from "./jd-button.vue?vue&type=template&id=3e4257be&scoped=true"
import script from "./jd-button.vue?vue&type=script&lang=js"
export * from "./jd-button.vue?vue&type=script&lang=js"
import style0 from "./jd-button.vue?vue&type=style&index=0&id=3e4257be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4257be",
  null
  
)

export default component.exports